export default "__VITE_ASSET__H3Ak4gVN__"